/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { initiativeSummarySchema } from './initiativeSummarySchema';

export const teamWorkAllocationSchema = z.object({
  get initiatives() {
    return z.array(initiativeSummarySchema);
  },
  itemCount: z.int(),
  proportionalExpectedEffort: z.int(),
  proportionalHighEffort: z.int(),
  proportionalLowEffort: z.int(),
  teamId: z.int().nullish(),
});
